import api from './api';

export default {
  getParticipantAchievements({ participantId }) {
    return api.get(`/scount-achievements/api/v1/achievements/${participantId}`);
  },
  getTeamAchievements({ teamId }) {
    return api.get(`/scount-achievements/api/v1/team-achievements/teamId/${teamId}`);
  },
  getTeamAchievementsParticipants({ teamAchievementId }) {
    return api.get(`/scount-achievements/api/v1/team-achievements/${teamAchievementId}`);
  },
};
